import { GridCellParams, GridColDef } from '@mui/x-data-grid'
import OverlayNoRowsTable from 'components/OverlayNoRowsTable/OverlayNoRowsTable'
import { ReactComponent as AttenSvg } from 'images/icons/attention.svg'
import { ReactComponent as SortIcon } from 'images/icons/sort_icon.svg'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { PATH } from 'utils/constants'
import { IRobotInfo } from 'utils/interfaces'
import { StyledDataGrid } from 'utils/themeGrid'

import style from './RobotListView.module.css'

const RobotList = ({ robots, error }: { robots: IRobotInfo[]; error?: Error | null }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const columnsRobotList: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
      disableColumnMenu: true,
      flex: 0.05,
    },
    {
      field: 'name',
      headerName: t('robotHeader.name'),
      disableColumnMenu: true,
      flex: 0.15,
      renderCell: params => {
        const value = params.value
        const checkIcon = params.row.networkStatus === 'online'
        return (
          <div className={style.iconBox}>
            {value}
            {!checkIcon && (
              <div className={style.iconFlex}>
                <AttenSvg />
              </div>
            )}
          </div>
        )
      },
    },
    {
      field: 'mission',
      headerName: t('robotHeader.mission'),
      disableColumnMenu: true,
      flex: 0.15,
      valueGetter: params => params.row.job?.missionName,
    },
    {
      field: 'activeModeText',
      headerName: t('robotHeader.activeMode'),
      disableColumnMenu: true,
      flex: 0.1,
	  valueGetter: params => t('missionTypes.' + params.row.activeModeText)
    },
    {
      field: 'batteryPower',
      headerName: t('robotHeader.batteryLevel'),
      sortable: true,
      disableColumnMenu: true,
      flex: 0.1,
      valueGetter: params => params.row.batteryPower?.toFixed(),
    }
  ]

  const goToRobot = (missionId: number) => {
    navigate(`${PATH.ROBOT_LIST}/${missionId}`)
  }
  const handleClick = (params: GridCellParams) => {
    const cellValue = params.row.id
    goToRobot(cellValue)
  }

  if (error) return <div>{error.message}</div>

  return (
    <>
      <StyledDataGrid
        rows={robots}
        columns={columnsRobotList}
        showColumnVerticalBorder={false}
        showCellVerticalBorder={false}
        disableRowSelectionOnClick={true}
        autoHeight={true}
        hideFooter={true}
        columnHeaderHeight={35}
        slots={{
          columnSortedAscendingIcon: SortIcon,
          columnSortedDescendingIcon: SortIcon,
          noRowsOverlay: () => <OverlayNoRowsTable />,
        }}
        sx={{
          cursor: 'pointer',
          boxShadow: 0,
          border: 0,
          fontStyle: 'normal',
        }}
        onCellClick={params => {
          handleClick(params)
        }}
      />
    </>
  )
}

export default RobotList
